import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappChat.css";
const WhatsAppChat = () => {
  const phoneNumber = "917529019797";
  const message = "Hi! I would like to know more.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-chat"
      aria-label="Chat on WhatsApp"
    >
      <div className="whatsapp-icon">
        <FaWhatsapp />
      </div>

    </a>
  );
};

export default WhatsAppChat;